function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return <svg width="12" height="7" viewBox="0 0 12 7" {...props}><text transform="translate(-1 -5)" fillRule="nonzero" fontFamily="LucidaGrande, Lucida Grande" fontSize="14"><tspan x="0" y="14">→</tspan></text></svg>;
});